import { interpolate, FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { IS_MOBILE_APP_QUERY, Feature } from '@gig/magic-messages';
import { NotificationDelay } from '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import { notificationService } from '../../services/notifications/notifications.service.js';
import '../../services/live-chat/live-chat.service.js';

var NotificationsComponent = /** @class */ (function (_super) {
    __extends(NotificationsComponent, _super);
    function NotificationsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notifications = notificationService.notifications;
        _this.isToastNotification = false;
        _this.isTopNavEnabled = false;
        _this.isMobileApp = false;
        return _this;
    }
    NotificationsComponent.prototype.close = function (notification) {
        notificationService.close(notification);
    };
    NotificationsComponent.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, window.queryBus.query(IS_MOBILE_APP_QUERY)];
                    case 1:
                        _b.isMobileApp =
                            (_a = (_c.sent())) !== null && _a !== void 0 ? _a : false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * TODO:
     * improve this!
     * notification content can be string but also an element
     */
    NotificationsComponent.prototype.interpolate = function (text) {
        if (typeof text === 'string') {
            return interpolate(text, this.magicConfig.interpolationParams, true);
        }
        return text;
    };
    NotificationsComponent.prototype.progressVariant = function (closeDelay) {
        switch (closeDelay) {
            case NotificationDelay.DEFAULT:
                return 'default';
            case NotificationDelay.SHORT:
                return 'short';
            case NotificationDelay.LONG:
                return 'long';
            case NotificationDelay.PERMANENT:
                return 'permanent';
        }
    };
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TIMED_TOAST_NOTIFICATIONS,
        }),
        __metadata("design:type", Object)
    ], NotificationsComponent.prototype, "isToastNotification", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TOP_NAVIGATION,
        }),
        __metadata("design:type", Object)
    ], NotificationsComponent.prototype, "isTopNavEnabled", void 0);
    NotificationsComponent = __decorate([
        Component({
            name: 'notifications',
        })
    ], NotificationsComponent);
    return NotificationsComponent;
}(Mixins(MagicConfigMixin)));

export default NotificationsComponent;
